import axios from 'axios'
import router from '@/router'
import { Toast } from 'vant'

const BASE_URL = '/api'

let unauthorizedHandling = false

function buildQuery(params = {}) {
  const query = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&')
  return query ? `?${query}` : ''
}

function handleUnauthorized() {
  localStorage.removeItem('token')
  if (unauthorizedHandling) {
    return
  }
  unauthorizedHandling = true
  Toast({
    message: '登录已过期，请重新登录',
    duration: 1600
  })
  setTimeout(() => {
    unauthorizedHandling = false
    const currentPath = router.currentRoute.path
    if (currentPath !== '/login') {
      router.push('/login')
    }
  }, 800)
}

const service = axios.create({
  baseURL: BASE_URL,
  timeout: 15000*60
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    const data = response.data
    if (data && data.code === 401) {
      handleUnauthorized()
      return Promise.reject({
        ...data,
        msg: '登录已过期，请重新登录',
        handled: true
      })
    }
    if (data && data.code !== undefined && data.code !== 200) {
      return Promise.reject(data)
    }
    if (data && data.data !== undefined) {
      return data.data
    }
    return data
  },
  error => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
      return Promise.reject({
        code: 401,
        msg: '登录已过期，请重新登录',
        handled: true
      })
    }
    return Promise.reject(error)
  }
)

function request(path, params = {}, options = {}) {
  const method = options.method || 'GET'
  const config = {
    method,
    url: path + (method === 'GET' ? buildQuery(params) : '')
  }
  if (method !== 'GET') {
    config.data = params
  }
  return service(config)
}

function post(path, data = {}) {
  return request(path, data, { method: 'POST' })
}

export function imageUrl(path) {
  if (!path) return ''
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path
  return BASE_URL + (path.startsWith('/') ? path : '/' + path)
}

export function getBannerList() {
  return request('/mall/retailer/list/hot', { hot: 1,pageNum:1,pageSize:12 })
}

export function getHotList(params = {}) {
  return request('/mall/retailer/list/hot', { hot: 1, ...params })
}

export function getCommissionList(params = {}) {
  return request('/mall/retailer/list/commission', params)
}

export function getCreateTimeList(params = {}) {
  return request('/mall/retailer/list/id', params)
}

export function getMerchantDetail(id) {
  return request(`/mall/retailer/${id}`)
    .then(data => ({
      merchant: data
    }))
    .catch(() => {
      Toast({ message: '商家详情加载失败', duration: 1600 })
      return { merchant: null }
    })
}

export function submitMemberSubmission(platformId, data) {
  return post(`/mall/submission/batchReport/${platformId}`, data)
}

export function getMemberShortLink(retailerId) {
  return request(`/shortLink/getMemberShortLink/${retailerId}`)
}

export function getCategoryList() {
  return request('/mall/category/list').then(categoryList => ({
    categories: [{ id: 'hot', name: '热门', type: 'hot' }, ...(categoryList || []).map(item => ({
      id: item.id,
      name: item.categoryName,
      type: 'category'
    }))]
  }))
}

export function getRetailerListByCategory(params = {}) {
  const keyword = (params.keyword || '').trim().toLowerCase()
  const categoryId = params.categoryId || 'hot'
  const websiteParams = { retailerName: keyword }
  if (categoryId === 'hot') {
    websiteParams.hot = 1
  } else {
    websiteParams.productCategoryId = categoryId
  }
  if (params.pageNum) {
    websiteParams.pageNum = params.pageNum
  }
  if (params.pageSize) {
    websiteParams.pageSize = params.pageSize
  }
  return request('/mall/retailer/list/category', websiteParams)
}

export function getNoticeList(params = {}) {
  return request('/notice/list', params).then(res => ({
    rows: (res.rows || []).map(item => ({
      id: item.noticeId,
      isRead: item.isRead,
      title: item.noticeTitle,
      content: '',
      createTime: item.createTime
    })),
    total: res.total || 0
  }))
}

export function getMemberNoticeList(params = {}) {
  return request('/memberNotice/list', params).then(res => ({
    rows: (res.rows || []).map(item => ({
      id: item.id,
      isRead: item.readFinish,
      title: '',
      content: item.noticeContent,
      createTime: item.createTime
    })),
    total: res.total || 0
  }))
}

export function readAllMemberNotice(data = {}) {
  return post('/memberNotice/readAll',data)
}

export function getNoticeDetail(id) {
  return request(`/notice/detail/${id}`)
}

export function getHomePopup() {
  return request('/notice/getHomePopup')
}

export function getLoginMember() {
  const token = localStorage.getItem('token')
  return token || null
}

export function logoutMember() {
  localStorage.removeItem('token')
}

export function getMineData() {
  const token = getLoginMember()
  if (!token) {
    return Promise.resolve({
      yesterdayEstimateCommission: 0,
      lastMonthCommission: 0,
      withdrawableCommission: 0,
      frozenCommission: 0,
      currentMonthCommission: 0,
      account: '',
      createTime:'',
			readFinish:1
    })
  }
  return request('/memberCenter/info')
    .then(res => ({
      yesterdayEstimateCommission: res.yesterdayEstimateCommission || 0,
      lastMonthCommission: res.lastMonthCommission || 0,
      withdrawableCommission: res.withdrawableCommission||0,
      frozenCommission: res.frozenCommission || 0,
      currentMonthCommission: res.currentMonthCommission || 0,
      account: res.account || '',
      createTime: res.createTime || '',
			readFinish: res.readFinish
    }))
    .catch(() => ({
      yesterdayEstimateCommission: 0,
      lastMonthCommission: 0,
      withdrawableCommission: 0,
      frozenCommission: 0,
      currentMonthCommission: 0,
      account: '',
      createTime:'',
			readFinish:1
    }))
}

export function getFindPasswordEmailValidCode(email) {
  return request('/mall/auth/getFindPasswordEmailValidCode', { email })
}

export function resetPassword(data) {
  return post('/mall/auth/resetPwd', data)
}

export function getCaptchaImage() {
  return request('/captchaImage')
}

export function loginMember(data) {
  return post('/mall/auth/login', data)
}

export function saveLogin(data = {}) {
  if (data.token) {
    localStorage.setItem('token', data.token)
  }
}

export function registerMember(data) {
  return post('/mall/auth/register', data)
}

export function sendEmailCode(email) {
  return request('/mall/auth/emailCode', { email })
}

export function getEstimateOrderList(year, month, params = {}) {
  return request(`/memberOrder/list/estimate/${year}/${month}`, params)
}

export function getSettlementOrderList(year, month, params = {}) {
  return request(`/memberOrder/list/settlement/${year}/${month}`, params)
}

export function getLastSummaryReport() {
  return request('/mall/submission/getLastSummaryReport')
}

export function importLast20DetailData() {
  return request('/mall/submission/importLast20DetailData')
}

export function getSubmissionList(params = {}) {
  return request('/mall/submission/list', params)
}

export function getAutoSubmissionList(params = {}) {
  return request('/openLinkSubmission/list', params)
}

export function getWithdrawInfo() {
  return request('/mall/withdraw/info')
}

export function saveWithdrawAccount(data) {
  return post('/mall/withdraw/account', data)
}

export function submitWithdrawApply(data) {
  return post('/mall/withdraw/apply', data)
}

export function listWithdrawApply(params = {}) {
  return request('/mall/withdraw/list', params)
}

export function withdrawChangeRecord(params = {}) {
  return request('/memberWithdrawChangeRecord/list', params)
}
export function getCommissionReportInfo() {
  return request('/commissionReport/info')
}